import { z } from 'zod';
import { Strings } from '../constants/Strings';

// A factory (not a const) so validation messages resolve in the active language
// at the time the form is built.
export const createReportPlaceSchema = () => {
  const v = Strings.get().places.validation;
  return z.object({
    reason: z.string().trim().min(1, v.reportReasonRequired).max(500, v.reportReasonTooLong),
  });
};

export type ReportPlaceFormValues = z.infer<ReturnType<typeof createReportPlaceSchema>>;
